import { render, staticRenderFns } from "./LegendDot.vue?vue&type=template&id=72960afe&scoped=true"
import script from "./LegendDot.vue?vue&type=script&lang=js"
export * from "./LegendDot.vue?vue&type=script&lang=js"
import style0 from "./LegendDot.vue?vue&type=style&index=0&id=72960afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72960afe",
  null
  
)

export default component.exports